import type {
    DSColorsTuple,
    SemanticColorVariants,
} from '@myphx-engineering/phx-design-system/framework';

export const lillyPalette: Record<SemanticColorVariants, DSColorsTuple> = {
    gray: [
        '#F2F3FA',
        '#E0E2EA',
        '#CED0D9',
        '#B0B2BD',
        '#9295A1',
        '#7D808C',
        '#686B79',
        '#4B4E5E',
        '#333748',
        '#1B1F32',
    ],
    primary: [
        '#F9EEED',
        '#F4CFCD',
        '#EEB1AE',
        '#E9928E',
        '#E3736F',
        '#DE544F',
        '#D83630',
        '#D31710',
        '#BD1009',
        '#9C0B05',
    ],
    secondary: [
        '#F9EEED',
        '#F4CFCD',
        '#EEB1AE',
        '#E9928E',
        '#E3736F',
        '#DE544F',
        '#D83630',
        '#D31710',
        '#BD1009',
        '#9C0B05',
    ],
    error: [
        '#FDE7EC',
        '#FAC4D0',
        '#F7A1B5',
        '#F37E99',
        '#F05B7D',
        '#E15172',
        '#D14666',
        '#C23C5B',
        '#A62F4C',
        '#8A213D',
    ],
    info: [
        '#E7EFFB',
        '#C6D8F6',
        '#A4C1F0',
        '#83A9EB',
        '#6192E5',
        '#5382D3',
        '#4573C2',
        '#3763B0',
        '#2B579E',
        '#1E4A8B',
    ],
    warning: [
        '#FFF3CF',
        '#FFEDB0',
        '#FFE691',
        '#FFE071',
        '#FFD952',
        '#D9B73D',
        '#B49527',
        '#8E7312',
        '#77600D',
        '#5F4C07',
    ],
    success: [
        '#DEF2EF',
        '#CCE8E4',
        '#AACCC5',
        '#88B1A7',
        '#669588',
        '#447969',
        '#225E4B',
        '#00422C',
        '#003121',
        '#002116',
    ],
    notice: [
        '#FEECE3',
        '#FED7C4',
        '#FFC3A5',
        '#FFAE85',
        '#FF9966',
        '#E88459',
        '#D26F4B',
        '#BB5A3E',
        '#A14B32',
        '#873C26',
    ],
    saving: [
        '#DEF2EF',
        '#CCE8E4',
        '#AACCC5',
        '#88B1A7',
        '#669588',
        '#447969',
        '#225E4B',
        '#00422C',
        '#003121',
        '#002116',
    ],
};
